import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatDate(ts: number): string {
  return new Date(ts).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })
}

export function formatPercent(n: number): string {
  return `${Math.round(n * 100)}%`
}

export function formatWilson(wilson: [number, number]): string {
  return `${Math.round(wilson[0] * 100)}–${Math.round(wilson[1] * 100)}%`
}

export function getBandColor(band: 'Low' | 'Medium' | 'High'): string {
  if (band === 'High') return 'text-validation-green'
  if (band === 'Medium') return 'text-uncertainty-amber'
  return 'text-risk-rose'
}

export function getBandBg(band: 'Low' | 'Medium' | 'High'): string {
  if (band === 'High') return 'bg-green-50 border-validation-green/30 text-validation-green'
  if (band === 'Medium') return 'bg-amber-50 border-uncertainty-amber/30 text-uncertainty-amber'
  return 'bg-rose-50 border-risk-rose/30 text-risk-rose'
}

export function maskPII(value: string): string {
  if (!value) return ''
  if (value.includes('@')) {
    const [local, domain] = value.split('@')
    return `${local[0]}***@${domain}`
  }
  return value.slice(0, 2) + '***' + value.slice(-2)
}
